module.exports = __webpack_public_path__ + "img/portalhome.e79e4ae1.png";